import { useState } from 'react'
import { useDispatch } from 'react-redux'

import Button from '@/components/Button'
import DialogWrapper from '@/components/Dialog'
import TextArea from '@/components/TextArea'
import { useToast } from '@/components/Toast/ToastContext'
import { AppDispatch } from '@/store'
import { contactAdminThunk } from '@/store/features/member/memberSlice'

const INITIAL_MESSAGE = 'We should upgrade to an Enterprise plan'

interface UpgradeRequestDialogProps {
  isOpen: boolean
  onClose: () => void
}

const UpgradeRequestDialog = (props: UpgradeRequestDialogProps) => {
  const { isOpen, onClose } = props
  const dispatch = useDispatch<AppDispatch>()
  const [message, setMessage] = useState(INITIAL_MESSAGE)
  const [isSendingRequest, setIsSendingRequest] = useState(false)
  const { updateToast } = useToast()

  const handleRequestToUpgrade = async () => {
    try {
      setIsSendingRequest(true)
      await dispatch(
        contactAdminThunk({
          message,
        })
      ).unwrap()
      updateToast('Successfully sent message to admins', 'success')
      onClose()
    } catch (error) {
      console.error(error)
      updateToast(error as string, 'error')
      setIsSendingRequest(false)
    }
  }

  return (
    <DialogWrapper
      isOpen={isOpen}
      title="Request Upgrade"
      subtitle="Sent your admins a request to request an upgrade."
      close={onClose}
      minWidth={500}
    >
      <TextArea
        value={message}
        rows={6}
        onInput={setMessage}
        placeholder="We should upgrade to an Enterprise plan because..."
        isDisabled={isSendingRequest}
      />
      <Button title="Request Upgrade" onClick={handleRequestToUpgrade} type="dark" isLoading={isSendingRequest} />
    </DialogWrapper>
  )
}

export default UpgradeRequestDialog
